var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useRef } from 'react';
var MoveDirection;
(function (MoveDirection) {
    MoveDirection["Previous"] = "Previous";
    MoveDirection["Next"] = "Next";
    MoveDirection["First"] = "First";
    MoveDirection["Last"] = "Last";
})(MoveDirection || (MoveDirection = {}));
export var moveFocus = function (list, currentFocus, direction, menuItemSelector, preventScroll) {
    if (preventScroll === void 0) { preventScroll = false; }
    if (![currentFocus.parentNode, currentFocus].includes(list)) {
        return false;
    }
    var traversalFunction = [MoveDirection.First, MoveDirection.Next].includes(direction)
        ? function (item) { return item.nextElementSibling; }
        : function (item) { return item.previousElementSibling; };
    var nextFocus;
    if ([MoveDirection.First, MoveDirection.Last].includes(direction)) {
        nextFocus = direction === MoveDirection.First ? list.firstElementChild : list.lastElementChild;
    }
    else {
        nextFocus = traversalFunction(currentFocus);
    }
    while (nextFocus) {
        if (!nextFocus.matches(menuItemSelector)) {
            nextFocus = traversalFunction(nextFocus);
        }
        else {
            nextFocus.focus({ preventScroll: preventScroll });
            return true;
        }
    }
    return false;
};
export var useAccessibleMenu = function (containerRef, options) {
    var menuOptions = useMemo(function () { return (__assign({ focusFirstItemOnMount: true, menuItemSelector: '[role^="menuitem"]', isHorizontalMenu: false }, options)); }, [options]);
    var pendingFirstElementFocus = useRef(menuOptions.focusFirstItemOnMount);
    useEffect(function () {
        if (containerRef.current && pendingFirstElementFocus.current) {
            pendingFirstElementFocus.current = false;
            moveFocus(containerRef.current, containerRef.current, MoveDirection.First, menuOptions.menuItemSelector, true);
        }
    });
    return useMemo(function () {
        var onKeyDown = function (event) {
            var currentElement = document.activeElement;
            switch (event.key) {
                case 'ArrowDown':
                case 'ArrowUp':
                    if (menuOptions.isHorizontalMenu) {
                        break;
                    }
                    event.preventDefault();
                    moveFocus(containerRef.current, currentElement, event.key === 'ArrowUp' ? MoveDirection.Previous : MoveDirection.Next, menuOptions.menuItemSelector);
                    break;
                case 'ArrowLeft':
                case 'ArrowRight':
                    if (!menuOptions.isHorizontalMenu) {
                        break;
                    }
                    event.preventDefault();
                    moveFocus(containerRef.current, currentElement, event.key === 'ArrowLeft' ? MoveDirection.Previous : MoveDirection.Next, menuOptions.menuItemSelector);
                    break;
                case 'Home':
                    event.preventDefault();
                    moveFocus(containerRef.current, currentElement, MoveDirection.First, menuOptions.menuItemSelector);
                    break;
                case 'End':
                    event.preventDefault();
                    moveFocus(containerRef.current, currentElement, MoveDirection.Last, menuOptions.menuItemSelector);
                    break;
                case 'Enter':
                case ' ':
                    if (menuOptions.handleItemSelect &&
                        currentElement.matches(menuOptions.menuItemSelector)) {
                        menuOptions.handleItemSelect(event, currentElement);
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    if (menuOptions.handleClose)
                        menuOptions.handleClose(event);
                    break;
                default:
            }
        };
        var mouseAndPointerEvent = function (event) {
            var menuItem = event.target.closest(menuOptions.menuItemSelector);
            if (menuOptions.handleClose)
                menuOptions.handleClose(event);
            if (menuOptions.handleItemSelect && menuItem) {
                menuOptions.handleItemSelect(event, menuItem);
                event.preventDefault();
                event.stopPropagation();
            }
        };
        return { onKeyDown: onKeyDown, onClick: mouseAndPointerEvent, onTouchEnd: mouseAndPointerEvent };
    }, [containerRef, menuOptions]);
};
//# sourceMappingURL=useAccessibleMenu.js.map